import store from "../store/index";

const http = {
  fetch(
    url,
    data = null,
    successBadge = false,
    method = null,
    jsonDecode = true
  ) {
    if (store.state.logged === undefined && store.state.token === undefined) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.fetch(url, data, successBadge, method,jsonDecode)
            .then((data) => {
              resolve(data);
            })
            .catch((err) => {
              reject(err);
            });
        }, 1000);
      });
    }
    return new Promise((resolve, reject) => {
      let obj = {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + store.state.token,
        },
      };
      if (data !== null) {
        let body = new FormData();

        for (const key in data) {
          if (typeof data[key] === "object" && !(data[key] instanceof File)) {
            if (key === "tags" && data[key]?.length === 0) {
              body.append(`${key}`, null);
            }
            for (const key2 in data[key]) {
              if (typeof data[key][key2] === "object") {
                for (const key3 in data[key][key2]) {
                  if (typeof data[key][key2][key3] === "object") {
                    for (const key4 in data[key][key2][key3]) {
                      body.append(
                        `${key}[${key2}][${key3}][${key4}]`,
                        data[key][key2][key3][key4]
                      );
                    }
                  } else {
                    body.append(
                      `${key}[${key2}][${key3}]`,
                      data[key][key2][key3]
                    );
                  }
                }
              } else {
                body.append(`${key}[${key2}]`, data[key][key2]);
              }
            }
          } else {
            body.append(key, data[key]);
          }
        }

        obj.method = "POST";
        if (method !== null) {
          body.append("_method", method);
        }
        obj.body = body;
      }
      fetch(process.env.VUE_APP_API + "" + url, obj)
        .then((res) => {
          if (!jsonDecode) {
            return res.text();
          } else {
            if (!res.ok) {
              const error = new Error(res.statusText);
              error.json = res.json();
              throw error;
            }
            return res.json();
          }
        })
        .then((data) => {
          if (successBadge) {
            store.commit("setApiSuccess", data);
          }
          resolve(data);
        })
        .catch((err) => {
          err.json.then((data) => {
            if (data.message === "Unauthenticated.") {
              store.commit("logout");
              window.location.href = process.env.VUE_APP_MANAGER_URL;
            } else if (data.message === "Forbidden.") {
              store.commit("setApiError", data);
            } else if (successBadge) {
              store.commit("setApiError", data);
            }
            reject(data);
          });
        });
    });
  },
};

export default http;
